
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/carrinho",
      function () {
        return require("private-next-pages/carrinho/index.ts");
      }
    ]);
  